<template>
  <div>
    <div v-if="showModalErr">
        <transition name="modal">
          <div class="modal-mask" style="z-index: 9999">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Thông báo
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      @click="$emit('close')"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img
                      src="@/assets/img/noti-unsuccess2.svg"
                      alt="icon-successs"
                    />
                    <h2 class="f18 py-3">{{ messErr }}</h2>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="$emit('close')"
                      data-dismiss="modal"
                    >
                      Bỏ qua
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
  </div>
</template>

<script>
export default {
  props: ['showModalErr', 'messErr'],
  data () {
    return {

    }
  }
}
</script>

<style scoped>

</style>
